<template>
  <div class="zzzd_homeContainer">
    <div class="zzzd_HCWrapper" v-if="secondList">
      <div class="zzzd_steps" style="margin-left:20px">
        <div class="zzzd_circle active">1</div>
        <div class="zzzd_step active">入驻类型</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle">2</div>
        <div class="zzzd_step">基础评估</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle">3</div>
        <div class="zzzd_step">智能诊断</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle">4</div>
        <div class="zzzd_step">诊断结果</div>
      </div>
      <div class="zzzd_title">入驻类型</div>
      <div class="zzzd_content">
        <!-- 是否进口 -->
        <!-- <div class="zzzd_contentTitle">是否进口</div>
        <el-radio-group v-model="isImports" style="margin-bottom:35px">
          <el-radio :label="true">进口</el-radio>
          <el-radio :label="false">非进口</el-radio>
        </el-radio-group>-->
        <!-- 店铺类型 -->
        <div class="zzzd_contentTitle">主体性质</div>
        <el-radio-group v-model="shopId">
          <el-radio
            :label="item.id"
            v-for="(item,index) in shopList"
            :key="index"
            style="margin-right:82px"
            @change="changeShopType(index,item)"
          >{{item.name}}</el-radio>
        </el-radio-group>
        <!-- <div style="height:197px">
          <img src="@/assets/imgs/zzzd/旗舰店.png" alt v-if="shopId===30" />
          <img src="@/assets/imgs/zzzd/专卖店.png" alt v-if="shopId===31" />
          <img src="@/assets/imgs/zzzd/专营店.png" alt v-if="shopId===32" />
        </div>-->
        <div class="zzzd_table">
          <div class="zzzd_th">选择行业</div>
          <div class="zzzd_td">
            <!-- 选择行业(一级行业) -->
            <div class="zzzd_tdLeft" >
              <div
                v-for="(item,index) in industryList"
                :key="index"
                class="zzzd_leftWrap"
                @click="changeIndustry(index,item)"
              >
                <span
                  class="zzzd_tdLeft_item"
                  :class="{active:item.id === industryId}"
                >{{item.name}}</span>
              </div>
            </div>
            <!-- 选择行业(二级行业) -->
            <div class="zzzd_tdRight">
              <div class="zzzd_RightWrap">
                <div
                  v-for="(item,index) in secondList"
                  :key="index"
                  class="zzzd_tdRight_item"
                  @click="changeSecondIndustry(index,item)"
                  :class="{active:item.isChoice}"
                >{{item.name}}</div>
              </div>
              <!-- <div class="zzzd_confirmBtn" @click="startEvaluate">确定</div> -->
            </div>
          </div>
        </div>
        <div class="zzzd_title">输入企业联系人信息</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          :inline="true"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="企业名称" prop="name" class="zzzd_name">
                <el-input v-model="ruleForm.name" placeholder="请输入企业名称" style="width:400px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone" class="zzzd_phone">
                <el-input v-model="ruleForm.phone" placeholder="请输入联系电话" maxlength="11" style="width:400px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button @click="submitForm('ruleForm')">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getIndustries, // 获取一级分类，
  getSecondIndustries, // 获取二级分类，
} from "@/api/qualification.js";
import { logout } from "@/api/user";
import { getCookie, removeCookie } from "@/utils/getToken.js";
export default {
  data() {
    let validateName = (rule, value, callback) => {
      let reg = /\S/g;
      if (!reg.test(value)) {
        callback(new Error("公司名称不能为空"));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("格式不正确"));
      } else {
        callback();
      }
    };
    return {
      tableData: [],
      // isImports: true,
      // importList: ["进口", "非进口"],
      shopList: [
        { id: 33, name: "企业" },
        { id: 34, name: "民办非企业" },
        { id: 35, name: "个体工商户" },
        { id: 36, name: "法律服务" },
      ],
      shopId: 33,
      storeType: "企业",
      industryList: [],
      industryIndex: 0,
      secondList: [],
      industryId: "", //点击确定的一级分类
      secondId: "",
      nodeIndex: 0,
      industryName: "",
      platformCode: null,
      secondArr: [], //已经选择的二级分类
      ruleForm: {
        name: "",
        phone: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          {
            validator: validateName,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: validatePhone,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //选择入驻类型
    changeType(index) {
      this.typeId = index;
    },
    // 选择店铺类型
    changeShopType(index, item) {
      this.shopId = item.id;
      this.storeType = item.name;
    },
    // 点击一级分类
    changeIndustry(index, item) {
      if(this.industryId != item.id){
          this.industryId = item.id;
          this.industryName = item.name;
          // 获取二级分类
          let params = {
            industryId: item.id,
            platformCode: 11,
          };
          getSecondIndustries(params).then((res) => {
            if (res.status === 0) {
              this.secondList = res.data;
              this.secondId = res.data[0].id;
              res.data[0].isChoice = true;
            }else if(res.status == -99){
              this.$message('登录超时，请重新登录')
              this.logout()
            }
          });
      }

    },
    //点击二级分类
    changeSecondIndustry(index, item) {
      let len = this.secondArr.length;
      if (len === 0) {
        this.secondArr.push({ id: item.id, name: item.name });
      } else {
        let res = this.secondArr.some((itemR) => {
          return itemR.name === item.name;
        });
        if (res) {
          let index = this.secondArr.indexOf({ id: item.id, name: item.name });
          this.secondArr.splice(index, 1);
        } else {
          this.secondArr.push({ id: item.id, name: item.name });
        }
      }
      // console.log(this.secondArr)
      this.secondId = item.id;
      item.isChoice = !item.isChoice;
    },
    // 开始入住评估
    startEvaluate() {
      // let isImports;
      // this.typeId === 0 ? (isImports = true) : (isImports = false);
      this.secondArr = this.secondList.filter((item) => {
        return item.isChoice === true;
      });
      if (this.secondArr.length == 0) {
        this.$message("选择至少一个二级分类");
      } else {
        let mainClass = [];
        this.secondArr.forEach((item) => {
          mainClass.push(`${this.industryName}-${item.name}`);
        });
        let corporateType;
        switch (this.storeType) {
          case "企业":
            corporateType = "qy";
            break;
          case "个体工商户":
            corporateType = "gtgsh";
            break;
          case "民办非企业":
            corporateType = "mbfqy";
            break;
          case "法律服务":
            corporateType = "flfw";
            break;
          default:
            break;
        }
        let obj = {
          company_name: this.ruleForm.name, //公司名称
          platformCode: 11, //直播平台
          isImports: this.isImports || "", //是否进口
          storeTypeId: this.shopId, //店铺类型id
          storeType: this.storeType, //店铺类型
          industryId: this.industryId, //一级行业ID
          industryName: this.industryName, //行业名称
          secondIndustry: this.secondList,
          mainClass,
          corporateType,
          diagnosisType: "zb",
        };
        // console.log(obj);
        localStorage.setItem("getQualification", JSON.stringify(obj));
        localStorage.setItem("mainClass", JSON.stringify(mainClass));
        this.$router.push({ path: "/diagnose/Liveplatform/baseEvaluate" });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          localStorage.setItem("companyName", this.ruleForm.name);
          localStorage.setItem("companyphone", this.ruleForm.phone);
          this.startEvaluate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    logout() {
      logout(getCookie("userpin")).then((res) => {
        if (res.status == 0) {
          removeCookie("userpin");
          removeCookie("username");
          // this.$message({
          //   message: "已退出登录！",
          //   type: "success",
          // });
          this.$router.push("/diagnose");
        } else {
          this.$message.error("退出登录失败！");
        }
      });
    },
  },
  mounted() {
    // 获取一级分类
    getIndustries({ platformCode: 11 }).then((res) => {
      if (res.status === 0) {
        this.industryList = res.data;
        this.industryId = res.data[0].id;
        this.industryName = res.data[0].name;
        // 获取二级分类
        getSecondIndustries({
          platformCode: 11,
          industryId: res.data[0].id,
        }).then((res) => {
          if (res.status === 0) {
            this.secondList = res.data;
            this.secondId = res.data[0].id;
            res.data[0].isChoice = true;
          }else if(res.status == -99){
            this.$message('登录超时，请重新登录')
            this.logout()
          }
        });
      }else if(res.status == -99){
        this.$message('登录超时，请重新登录')
        this.logout()
      }
    });
    // this.$emit('getMessage', '1234');
  },
};
</script>

<style lang="scss" scoped>
.zzzd_homeContainer {
  background: #ebecef;
  width: 100%;
  min-height: 100%;
  border-top: 1px solid #ebecef;
  padding-bottom: 29px;
  .zzzd_HCWrapper {
    width: 1190px;
    background: #fff;
    height: 90%;
    margin: 29px auto 0;
    box-sizing: border-box;
    padding: 20px 0;
    .zzzd_steps {
      display: flex;
      .zzzd_circle {
        width: 32px;
        height: 32px;
        color: #666;
        font-size: 16px;
        font-family: HelveticaNeue;
        line-height: 32px;
        text-align: center;
        border-radius: 50%;
        border: 1px solid rgba(221, 221, 221, 1);
        &.active {
          background: rgba(216, 55, 77, 1);
          border: 1px solid rgba(216, 55, 77, 1);
          color: #fff;
        }
      }
      .zzzd_step {
        width: 64px;
        height: 24px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666;
        line-height: 24px;
        margin: 4px 8px;
        &.active {
          font-weight: 500;
          color: #000;
        }
      }
      .zzzd_line {
        width: 192px;
        height: 1px;
        background: #dddddd;
        margin-top: 17px;
        margin-right: 15px;
        margin-left: 22px;
      }
    }
    .zzzd_title {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 50px;
      height: 50px;
      border-bottom: 1px solid #eeeeee;
      margin: 0 20px;
      margin-top: 30px;
    }
    .zzzd_content {
      padding: 25px 40px;
      /deep/.el-radio__input.is-checked .el-radio__inner {
        border-color: #d7443f !important;
        background: #d7443f !important;
      }
      /deep/.el-radio__input.is-checked + .el-radio__label {
        color: #d7443f !important;
      }
      .zzzd_contentTitle {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 25px;
        margin-bottom: 20px;
      }
      .demo-ruleForm {
        margin-top: 20px;
        .el-form-item__content {
          width: 400px;
        }
        .el-button {
          width: 249px;
          height: 62px;
          background: #d7443f;
          border-radius: 4px;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          margin-left: 443px;
          margin-top: 58px;
          margin-bottom: 35px;
        }
      }
    }
    .zzzd_table {
      width: 100%;
      border: 1px solid rgba(235, 235, 235, 1);
      margin-bottom: 30px;
      margin-top: 40px;
      .zzzd_th {
        width: 100%;
        height: 50px;
        background: rgba(245, 245, 245, 1);
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 50px;
        padding-left: 20px;
        box-sizing: border-box;
      }
      .zzzd_td {
        display: flex;
        height: 350px;
        .zzzd_tdLeft {
          width: 20%;
          border-right: 1px solid #eee;
          overflow: auto;
          .zzzd_leftWrap {
            height: 30px;
            text-align: center;
            line-height: 30px;
            cursor: pointer;
            .zzzd_tdLeft_item {
              &.active {
                font-weight: 500;
                color: #dd2d2d;
              }
            }
          }
        }
        .zzzd_tdRight {
          width: 80%;
          .zzzd_RightWrap {
            display: flex;
            flex-wrap: wrap;
            padding: 20px 0;
            justify-content: space-around;
            align-content: flex-start;
            .zzzd_tdRight_item {
              text-align: center;
              min-width: 200px;
              height: 35px;
              line-height: 35px;
              margin-bottom: 10px;
              cursor: pointer;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 500;
              color: rgba(11, 11, 11, 1);
              &.active {
                background: #d7443f;
                color: #fff;
              }
            }
          }
        }
      }
    }
    .zzzd_confirmBtn {
      cursor: pointer;
      width: 80px;
      height: 30px;
      background: #d7443f;
      border-radius: 2px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      letter-spacing: 1px;
      text-align: center;
      margin: 30px auto;
    }
  }
}
</style>